import BasicType from './BasicType';
import Money from './Money';

export default class PaxPrice implements BasicType {
    public fromPax: number;
    public price: Money;

    constructor(fromPax: number, price: Money) {
        this.fromPax = fromPax;
        this.price = price;
    }

    public toString(): string {
        return `>= ${this.fromPax} = ${this.price.toString()}`;
    }

    equals(other: PaxPrice): boolean {
        return this.fromPax === other.fromPax && this.price.equals(other.price);
    }

    public static fromJson(json: any): PaxPrice {
        return new PaxPrice(json.fromPax, Money.fromJson(json.price));
    }
}
